// The small interface the director drives the 3D camera through. The
// implementation lives inside the <Canvas> (CinematicCameraRig.tsx, mounted
// by Scene) and registers itself here; the director only ever sees this
// interface, so it can be tested with a fake.

import type { CameraPose } from './types.js';

export interface CinematicCamera {
  /** The current pose (camera position + OrbitControls target). */
  getPose(): CameraPose;
  /** Put the camera at `pose`, looking at its target. */
  setPose(pose: CameraPose): void;
  /**
   * true: the cinematic owns the camera (player orbit/pan/zoom disabled).
   * false: hand it back (controls re-enabled, leftover damping settled).
   */
  setActive(active: boolean): void;
  /** Golden-hour light strength, 0..1. */
  setGolden(amount: number): void;
}

let current: CinematicCamera | null = null;

/** Register the live camera; returns the matching unregister. */
export function registerCinematicCamera(camera: CinematicCamera): () => void {
  current = camera;
  return () => {
    if (current === camera) current = null;
  };
}

export function getCinematicCamera(): CinematicCamera | null {
  return current;
}
